function noop() {
  return undefined;
}

export function doReport(url) {
  var reportObject = document.createElement('img');
  reportObject.onerror = reportObject.onload = reportObject.onabort = noop;
  reportObject.src = url + '&_dc=' + Math.random();
}